(function () {
    'use strict';

    angular.module("imApp").factory("pohKeynoTopStatusService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 395,
                    parameters: parms || {}
                });
            },
            listPohTops: function (parms) {
                return $ihttp.post({
                    method: 396,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
